var test = function test(_a) {
  var regExp = _a.regExp,
    _b = _a.message,
    message = _b === void 0 ? 'Значение не корректно' : _b;
  return function (value) {
    if (value && value.search(regExp) !== -1) {
      return;
    }
    return message;
  };
};
export default test;
export { test };